import { atom } from "jotai";
import {
    INFO_WINDOW_BOOKING,
    INFO_WINDOW_TRAVELZONE,
    INFO_WINDOW_WAITLIST,
    DEFAULT_MAP_DATE_RANGE
} from "../../utils/Constants";

export const dateRangeAtom = atom(DEFAULT_MAP_DATE_RANGE);

export const providerLocationsFilterAtom = atom([]);
export const providerLocationsAtom = atom([]);
export const groupedProviderLocationsAtom = atom({});

export const filteredProviderLocationsAtom = atom((get) => {
    const filterProviderLocationIds = get(providerLocationsFilterAtom);
    const providerLocations = get(providerLocationsAtom);
    return filterProviderLocationIds && filterProviderLocationIds.length
        ? providerLocations?.filter((pl) =>
              filterProviderLocationIds.includes(pl.id)
          )
        : [];
});

export const filteredProvidersCountAtom = atom((get) => {
    const filterProviderLocationIds = get(providerLocationsFilterAtom);
    const groupedProviderLocations = get(groupedProviderLocationsAtom);
    const groupNames = Object.keys(groupedProviderLocations);
    let providerCount = 0;
    groupNames.forEach((groupName) => {
        const providerNames = Object.keys(groupedProviderLocations[groupName]);
        providerNames.forEach((providerName) => {
            if (
                groupedProviderLocations[groupName][providerName].ids.some(
                    (providerLocationId) =>
                        filterProviderLocationIds.includes(providerLocationId)
                )
            )
                providerCount++;
        });
    });
    return providerCount;
});

export const bookingsAtom = atom([]);
export const filteredBookingsAtom = atom((get) => {
    const filterProviderLocations = get(filteredProviderLocationsAtom);
    const filteredProviderIds = filterProviderLocations?.map(
        (pl) => pl.providerId
    );

    const bookings = get(bookingsAtom);
    return filteredProviderIds && filteredProviderIds.length
        ? bookings?.filter((booking) =>
              filteredProviderIds.includes(booking.providerId)
          )
        : [];
});

//address lookup
export const addressPlaceDetailsAtom = atom(null);
export const showActiveTravelZonesAtom = atom(true);
export const showExpiredTravelZonesAtom = atom(false);
export const showWaitlistAtom = atom(false);
export const openedInfoWindowTypeAtom = atom("INFO_WINDOW_NONE");
export const canShowBookingInfoWindowAtom = atom((get) => {
    const openedInfoWindow = get(openedInfoWindowTypeAtom);
    return openedInfoWindow === INFO_WINDOW_BOOKING;
});
export const canShowWaitlistInfoWindowAtom = atom((get) => {
    const openedInfoWindow = get(openedInfoWindowTypeAtom);
    return openedInfoWindow === INFO_WINDOW_WAITLIST;
});
export const canShowTravelZoneInfoWindowAtom = atom((get) => {
    const openedInfoWindow = get(openedInfoWindowTypeAtom);
    return openedInfoWindow === INFO_WINDOW_TRAVELZONE;
});
